export default {
  name: "TOS"
};